// extracted by mini-css-extract-plugin
export default {"root":"style-module__root___sLA1q","root__icon":"style-module__root__icon___aGIhn","root__name":"style-module__root__name___qBPqD","root__preview":"style-module__root__preview___INThi"};
    if(module.hot) {
      // 1729151125000
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  